import ACTIONS from '../actions';

export default function treatmentsReducer(state, action) {
  let updatedArray;
  switch(action.type) {
    case ACTIONS.GET_ALL_TREATMENTS:
      return {
        ...state,
        allTreatments: action.payload
      };
    case ACTIONS.CREATE_TREATMENT:
      updatedArray = [...state.allTreatments, action.payload]
      return {
        ...state,
        allTreatments: updatedArray
      };
    case ACTIONS.ADD_TREATMENT_COLLABORATOR:
      return {
        ...state,
        treatmentCollaborators: [ ...state.treatmentCollaborators, action.payload]
      }
    case ACTIONS.REMOVE_TREATMENT_COLLABORATOR:
      updatedArray = state.treatmentCollaborators.filter(c => c.user_id._id !== action.payload)
      return {
        ...state,
        treatmentCollaborators: updatedArray
      }
    case ACTIONS.GET_ALL_TREATMENT_COLLABORATORS:
      return {
        ...state,
        treatmentCollaborators: action.payload
      }
    case ACTIONS.GET_TREATMENT_MESSAGES:
      let obj = {};
      action.payload.forEach((data) => {
        obj[data._id] = data;
      });
      const updatedTreatmentMessages = {
        ...obj,
      };
      return { ...state, treatmentMessages: updatedTreatmentMessages };
    case ACTIONS.SET_NEW_MESSAGE:
      let newMessageObj = {};
      newMessageObj[action.payload._id] = action.payload;
      return {...state,treatmentMessages: {...state.treatmentMessages, ...newMessageObj}  };
    case ACTIONS.TREATMENT_CONVERSATION:
      return { ...state, treatmentConversation: action.payload }
    case ACTIONS.GET_TREATMENT_DOCUMENTS:
      return {
        ...state,
        treatmentDocuments: action.payload
      };
    case ACTIONS.DELETE_TREATMENT_DOCUMENT:
      const treatmentDocumentsBeforeDelete = [...state.treatmentDocuments];  
      const removeDeletedDocument = treatmentDocumentsBeforeDelete.filter(file => file.name !== action.payload);
    return {
        ...state,
        treatmentDocuments: removeDeletedDocument
      };
    case ACTIONS.UPLOAD_TREATMENT_DOCUMENT:
      const currentTreatmentDocuments = [...state.treatmentDocuments];
      const sameDocument = currentTreatmentDocuments.find(file => file.name === action.payload.name);
      let updatedTreatmentDocuments;
      if (sameDocument) {
        sameDocument.last_modified = action.payload.last_modified;
        sameDocument.size = action.payload.size;
        const allExceptSame = currentTreatmentDocuments.filter(file => file.name !== action.payload.name);
        updatedTreatmentDocuments = [...allExceptSame, sameDocument];
      };
      if (!sameDocument) {
        updatedTreatmentDocuments = [...state.treatmentDocuments, action.payload];  
      };
      return {
          ...state,
          treatmentDocuments: updatedTreatmentDocuments
        }
    case ACTIONS.GET_ALL_TREATMENT_TRANSACTIONS:
      let allTransactions = action.payload;  
      let paidTransactions = allTransactions.filter(transaction => transaction.is_paid);
      let unpaidTransactions = allTransactions.filter(transaction => !transaction.is_paid);
      return {
        ...state,
        treatmentTransactions: {
          paid: paidTransactions,
          unpaid: unpaidTransactions
        }
      };
    case ACTIONS.DELETE_TREATMENT:
      const treatments = [...state.allTreatments];
      const updatedTreatmentArray = treatments.map(treatment => {
        if (treatment._id === action.payload._id) return action.payload;
        return treatment;
      });
      return {
        ...state,
        allTreatments: updatedTreatmentArray
      };
    case ACTIONS.ERASE_TREATMENT:
      const removeTreatmentFromArray = treatments.filter(treatment => treatment._id !== action.payload._id) 
      return {
        ...state,
        allTreatments: removeTreatmentFromArray
      };
    default: 
      return state
  }
}